import { Link } from "react-router-dom";
import { scrollToSection } from "./scrollTo";

const NAV_LINKS = [
  { label: "Product", href: "#product" },
  { label: "Manifesto", href: "#manifesto" },
  { label: "Pricing", href: "#pricing" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/5 px-6 py-16" data-testid="footer">
      <div className="mx-auto max-w-7xl">
        <p className="font-display text-outline text-6xl font-black tracking-tight md:text-8xl">
          VEKTOR
        </p>
        <div className="mt-10 flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <p className="max-w-xs text-sm text-white/40">
            The single signal for teams who ship. Kanban, workload and time-off in one place.
          </p>
          <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-white/50">
            {NAV_LINKS.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollToSection(link.href)}
                className="transition-colors duration-200 hover:text-[#00FF66]"
                data-testid={`footer-link-${link.label.toLowerCase()}`}
              >
                {link.label}
              </button>
            ))}
            <Link to="/about" className="transition-colors duration-200 hover:text-[#00FF66]" data-testid="footer-link-about">
              About
            </Link>
            <Link to="/changelog" className="transition-colors duration-200 hover:text-[#00FF66]" data-testid="footer-link-changelog">
              Changelog
            </Link>
            <Link to="/privacy" className="transition-colors duration-200 hover:text-[#00FF66]" data-testid="footer-link-privacy">
              Privacy
            </Link>
            <Link to="/terms" className="transition-colors duration-200 hover:text-[#00FF66]" data-testid="footer-link-terms">
              Terms
            </Link>
          </div>
        </div>
        <p className="mt-10 text-xs text-white/25">© 2026 Vektor. All lanes reserved.</p>
      </div>
    </footer>
  );
}
